import styled from 'styled-components';
import React from 'react';
import { CarGuideCardProps } from '~/App/views/Carguide/types';
import CarGuideMatchedList from '~/App/shared/components/ProductCard/components/CarGuideMatchedList';
import { useTranslation } from '~/Locale';
import Divider from '~/App/shared/components/Divider';

const Container = styled.div`
  position: relative;
`;

export interface Props {
  carGuideCardProps: CarGuideCardProps;
}

const CarGuideMatchingInfo = ({ carGuideCardProps }: Props) => {
  const { t } = useTranslation();
  return (
    <Container data-testid="car-guide-matching-info">
      <Divider height={0} />
      {carGuideCardProps.criterias.important.length !== 0 && (
        <CarGuideMatchedList
          matched={carGuideCardProps.criterias.important}
          title={t('Very')}
          questions={carGuideCardProps.questions}
        />
      )}
      {carGuideCardProps.criterias.niceToHave.length !== 0 && (
        <CarGuideMatchedList
          matched={carGuideCardProps.criterias.niceToHave}
          title={t('A little')}
          questions={carGuideCardProps.questions}
        />
      )}
    </Container>
  );
};

export default CarGuideMatchingInfo;
